module.exports = __webpack_public_path__ + "static/media/logo_white.8ad5e66d.png";